// Carry Roll Delivery model — swing & club delivery (3.1–3.7). Pure functions.
/**
 * Derive launch/spin shifts from attack angle, dynamic loft (3.1, 3.2);
 * face-to-path (3.5); gear-effect spin-axis shift + ball-speed adjustment (3.6);
 * dynamic lie angle (3.7).
 */
export function deriveDelivery(delivery, launch) {
    const result = {
        launch: {},
        spinAxisShiftDeg: 0,
        ballSpeedFactor: 1,
        faceToPathDeg: null,
        lateralShiftDeg: 0,
    };
    if (!delivery)
        return result;
    // Face-to-path (3.5)
    if (delivery.clubPathDeg != null && delivery.faceAngleDeg != null) {
        result.faceToPathDeg = delivery.faceAngleDeg - delivery.clubPathDeg;
    }
    // Attack angle shifts launch angle (3.1): positive attack → higher launch
    if (delivery.attackAngleDeg != null) {
        const launchShiftRad = (delivery.attackAngleDeg * 0.15 * Math.PI) / 180;
        result.launch.launchAngle = launch.launchAngle + launchShiftRad;
    }
    // Dynamic loft shifts spin (3.2): higher loft → more spin
    if (delivery.dynamicLoftDeg != null) {
        const spinShift = (delivery.dynamicLoftDeg - 30) * 80;
        result.launch.spinRpm = Math.max(0, launch.spinRpm + spinShift);
    }
    // Gear effect from impact location (3.6): heel/toe offset tilts spin axis
    if (delivery.impactMm != null) {
        const [heelToe] = delivery.impactMm;
        // Heel strike (negative) → gear effect tilts axis; toe (positive) → opposite
        result.spinAxisShiftDeg = -heelToe * 0.4;
        // Off-center hits reduce ball speed slightly
        const offCenter = Math.hypot(heelToe, delivery.impactMm[1] ?? 0);
        result.ballSpeedFactor = Math.max(0.92, 1 - offCenter / 100);
    }
    // Dynamic lie angle (3.7): non-level sole shifts launch direction laterally.
    // Toe-down (lieAngleDeg > 0) pushes ball left; heel-down pushes right.
    if (delivery.lieAngleDeg != null) {
        const lieShift = delivery.lieAngleDeg * 0.3;
        result.lateralShiftDeg = lieShift;
        result.spinAxisShiftDeg += lieShift * 0.2;
    }
    return result;
}
//# sourceMappingURL=delivery.js.map